import { Injectable } from '@angular/core';
import { AngularCommonModuleConfig } from '../model/AngularCommonModuleConfig';
import { HttpClient } from '@angular/common/http';
import { VerifySoftwareTokenCommand } from '@clearing-hub/command';
import { Observable } from 'rxjs';

@Injectable()
export class AngularCommonService {
  public static config: AngularCommonModuleConfig;

  constructor(private readonly http: HttpClient) {
  }

  associateSoftwareToken(): Observable<any> {
    return this.http.post('/api/authentication/associate-software-token', {});
  }

  verifySoftwareToken(command: VerifySoftwareTokenCommand) {
    return this.http.post('/api/authentication/verify-software-token', command);
  }

  logout() {
    return this.http.post('/api/authentication/signout', {});
  }
}
